import React from "react";

export const useLocalStorageState = (defaultValue: any, key: string) => {
	const [value, setValue] = React.useState(() => {
		const stickyValue = window.localStorage.getItem(key);
		return stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
	});

	React.useEffect(() => {
		window.localStorage.setItem(key, JSON.stringify(value));
	}, [key, value]);
	React.useEffect(() => {
		const sync = (event: StorageEvent) => {
			if (event.key === key) setValue(event.newValue === null ? defaultValue : JSON.parse(event.newValue));
		};
		window.addEventListener("storage", sync);
		return () => window.removeEventListener("storage", sync);
	}, [key, defaultValue]);

	return [value, setValue];
};
